<template>
  <div class="metric-panel">
    <div class="metric-panel__header">
      <div class="metric-panel__title-wrap">
        <span class="metric-panel__dot" :style="{ background: color }" />
        <div>
          <div class="metric-panel__title">{{ title }}</div>
          <div class="metric-panel__desc">{{ desc }}</div>
        </div>
      </div>
      <div class="metric-panel__total">
        合计 <span>¥ {{ formatAmount(total) }}</span>
      </div>
    </div>

    <el-table
      v-if="rows.length"
      :data="rows"
      size="small"
      max-height="300"
      :header-cell-style="{ background: '#fafafa', color: '#606266' }"
    >
      <el-table-column type="index" label="#" width="48" />
      <el-table-column
        :label="nameLabel"
        prop="name"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column label="金额(元)" prop="amount" width="120" align="right">
        <template slot-scope="scope">
          {{ formatAmount(scope.row.amount) }}
        </template>
      </el-table-column>
      <el-table-column label="占比" width="140" align="center">
        <template slot-scope="scope">
          <div class="ratio-cell">
            <el-progress
              :percentage="getPercent(scope.row.amount)"
              :color="color"
              :show-text="false"
              :stroke-width="8"
            />
            <span class="ratio-text">{{ getPercent(scope.row.amount) }}%</span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div v-else class="metric-panel__empty">暂无数据</div>
  </div>
</template>

<script>
export default {
  name: "MetricPanel",
  props: {
    title: String,
    desc: String,
    color: {
      type: String,
      default: "#1890ff",
    },
    nameLabel: {
      type: String,
      default: "名称",
    },
    rows: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    formatAmount(value) {
      const num = Number(value) || 0;
      return num.toLocaleString("zh-CN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getPercent(amount) {
      if (!this.total) return 0;
      return Math.min(100, Math.round((amount / this.total) * 1000) / 10);
    },
  },
};
</script>

<style lang="scss" scoped>
.metric-panel {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 14px 16px 12px;
  margin-bottom: 16px;
  height: calc(100% - 16px);

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12px;
  }

  &__title-wrap {
    display: flex;
    gap: 10px;
    flex: 1;
    min-width: 0;
  }

  &__dot {
    width: 4px;
    height: 40px;
    border-radius: 2px;
    flex-shrink: 0;
    margin-top: 2px;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
  }

  &__desc {
    margin-top: 4px;
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
  }

  &__total {
    flex-shrink: 0;
    font-size: 12px;
    color: #909399;
    text-align: right;
    white-space: nowrap;

    span {
      display: block;
      margin-top: 4px;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }
  }

  &__empty {
    padding: 40px 0;
    text-align: center;
    color: #c0c4cc;
    font-size: 13px;
  }
}

.ratio-cell {
  display: flex;
  align-items: center;
  gap: 8px;

  .el-progress {
    flex: 1;
  }
}

.ratio-text {
  width: 42px;
  font-size: 12px;
  color: #606266;
  text-align: right;
}
</style>
